import { toast } from '@/common/util'
import baseApi from './base.api'
import type { PropsTestEmailType } from '@/types/types'

export default {
  ...baseApi,
  resource: 'NotificacaoAutomatizada',
  async sendTestEmail(props: PropsTestEmailType) {
    try {
      return await this.post('SendTestEmail', {
        email: props.email,
        body: props.template,
        assunto: props.subject,
        evento: props.eventType
      })
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({message: notifications[0] || 'Erro ao tentar enviar um e-mail de teste'})
    }
  },

  async executePerTenant(notificationId: string) {
    try {
      return await this.post(`${notificationId}/ExecutePerTenant`)
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({ message: notifications[0] || 'Erro ao tentar executar o fluxo de notificação' })
    }
  }
}